(() => {
    class PasswordResetModalController {
        constructor(
            $scope,
            $uibModalInstance
        ) {
            $scope.closeModal = $uibModalInstance.close;
        }
    }

    angular.module("dashboard")
        .controller("PasswordResetModalController", [
            "$scope",
            "$uibModalInstance",
            PasswordResetModalController
        ]);
})();
